import React, { useMemo } from 'react';
import { useTable, Column } from 'react-table';
import './././../../components/data-tables/DataTable.scss';

interface WellStatusOverview {
  label: string;
  value: string;
  isVisible: boolean;
  displayState: number;
}

interface TaskDataTableProps {
  data: WellStatusOverview[];
  parentComponent?: string;
}

const RodLiftStatusOverviewTable: React.FC<TaskDataTableProps> = ({ data, parentComponent = '' }) => {
  const visibleData = useMemo(() => {
    if (!data || data.length === 0) {
      return [];
    }
    return data.filter((item) => item.isVisible && item.label.trim() !== '');
  }, [data]);
  const isRenderedfromLocationsModule = parentComponent === 'WellLocations'; // Identifying if its rendered inside Locations Module
  const columns: Column<WellStatusOverview>[] = useMemo(
    () => [
      {
        accessor: 'label',
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        accessor: 'value',
        Cell: ({ value }) => <span>{value}</span>,
      },
    ],
    [],
  );

  const { getTableProps, getTableBodyProps, rows, prepareRow } = useTable({
    columns,
    data: visibleData,
  });

  return (
    <section className={`table-container-wrapper mt-4 widget-table-wrapper 
      ${isRenderedfromLocationsModule ? '!max-h-[calc(100vh-200px)] !h-[calc(100vh-200px)] max-w-[348px]' : ''}`}>
      <div className={`table-container p-0 ${isRenderedfromLocationsModule ? '!m-[0px] border-none !border-t-none !max-h-[calc(100vh-200px)] !h-[calc(100vh-200px)] max-w-[348px]' : ''}`}>
        <div className={`table-wrapper ${isRenderedfromLocationsModule ? '!max-h-[calc(100vh-400px)] !h-[calc(100vh-400px)] max-w-[348px]' : ''}`}>
          <table {...getTableProps()} className={`data-table widget-table center-text table ${isRenderedfromLocationsModule ? '!max-w-[320px] !min-w-[150px] !border-[none] !h-[calc(100vh-450px)]' : ''}`}>
            <thead></thead>

            <tbody {...getTableBodyProps()}>
              {rows.length > 0 ? (
                rows.map((row, rowIndex) => {
                  prepareRow(row);
                  const isLastRow = rowIndex === rows.length - 1;
                  return (
                    <tr {...row.getRowProps()} className='table-row'>
                      {row.cells.map((cell, index) => (
                        <td key={index} className={`table-cell ${isRenderedfromLocationsModule ? `!border-t-[0px] !whitespace-break-spaces break-words ${isLastRow ? '!border-b-0' : ''}` : ''}`} >
                          <div className={cell.column.id === 'label' ? 'text-left' : 'text-right'}>
                            {cell.render('Cell')}
                          </div>
                        </td>
                      ))}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={2} className='text-center'>
                    No Data Available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default RodLiftStatusOverviewTable;
